export const countryCodes = [
  { code: "+93", label: "🇦🇫 Afghanistan", country: "Afghanistan" },
  { code: "+355", label: "🇦🇱 Albania", country: "Albania" },
  { code: "+213", label: "🇩🇿 Algeria", country: "Algeria" },
  { code: "+376", label: "🇦🇩 Andorra", country: "Andorra" },
  { code: "+244", label: "🇦🇴 Angola", country: "Angola" },
  { code: "+54", label: "🇦🇷 Argentina", country: "Argentina" },
  { code: "+374", label: "🇦🇲 Armenia", country: "Armenia" },
  { code: "+61", label: "🇦🇺 Australia", country: "Australia" },
  { code: "+43", label: "🇦🇹 Austria", country: "Austria" },
  { code: "+994", label: "🇦🇿 Azerbaijan", country: "Azerbaijan" },
  { code: "+973", label: "🇧🇭 Bahrain", country: "Bahrain" },
  { code: "+880", label: "🇧🇩 Bangladesh", country: "Bangladesh" },
  { code: "+375", label: "🇧🇾 Belarus", country: "Belarus" },
  { code: "+32", label: "🇧🇪 Belgium", country: "Belgium" },
  { code: "+501", label: "🇧🇿 Belize", country: "Belize" },
  { code: "+229", label: "🇧🇯 Benin", country: "Benin" },
  { code: "+975", label: "🇧🇹 Bhutan", country: "Bhutan" },
  { code: "+591", label: "🇧🇴 Bolivia", country: "Bolivia" },
  { code: "+387", label: "🇧🇦 Bosnia", country: "Bosnia" },
  { code: "+267", label: "🇧🇼 Botswana", country: "Botswana" },
  { code: "+55", label: "🇧🇷 Brazil", country: "Brazil" },
  { code: "+673", label: "🇧🇳 Brunei", country: "Brunei" },
  { code: "+359", label: "🇧🇬 Bulgaria", country: "Bulgaria" },
  { code: "+226", label: "🇧🇫 Burkina Faso", country: "Burkina Faso" },
  { code: "+257", label: "🇧🇮 Burundi", country: "Burundi" },
  { code: "+855", label: "🇰🇭 Cambodia", country: "Cambodia" },
  { code: "+237", label: "🇨🇲 Cameroon", country: "Cameroon" },
  { code: "+1", label: "🇨🇦 Canada", country: "Canada" },
  { code: "+238", label: "🇨🇻 Cape Verde", country: "Cape Verde" },
  { code: "+236", label: "🇨🇫 Central African Republic", country: "CAR" },
  { code: "+235", label: "🇹🇩 Chad", country: "Chad" },
  { code: "+56", label: "🇨🇱 Chile", country: "Chile" },
  { code: "+86", label: "🇨🇳 China", country: "China" },
  { code: "+57", label: "🇨🇴 Colombia", country: "Colombia" },
  { code: "+269", label: "🇰🇲 Comoros", country: "Comoros" },
  { code: "+242", label: "🇨🇬 Congo", country: "Congo" },
  { code: "+506", label: "🇨🇷 Costa Rica", country: "Costa Rica" },
  { code: "+385", label: "🇭🇷 Croatia", country: "Croatia" },
  { code: "+53", label: "🇨🇺 Cuba", country: "Cuba" },
  { code: "+357", label: "🇨🇾 Cyprus", country: "Cyprus" },
  { code: "+420", label: "🇨🇿 Czech Republic", country: "Czech Republic" },
  { code: "+45", label: "🇩🇰 Denmark", country: "Denmark" },
  { code: "+253", label: "🇩🇯 Djibouti", country: "Djibouti" },
  { code: "+593", label: "🇪🇨 Ecuador", country: "Ecuador" },
  { code: "+20", label: "🇪🇬 Egypt", country: "Egypt" },
  { code: "+503", label: "🇸🇻 El Salvador", country: "El Salvador" },
  { code: "+372", label: "🇪🇪 Estonia", country: "Estonia" },
  { code: "+251", label: "🇪🇹 Ethiopia", country: "Ethiopia" },
  { code: "+679", label: "🇫🇯 Fiji", country: "Fiji" },
  { code: "+358", label: "🇫🇮 Finland", country: "Finland" },
  { code: "+33", label: "🇫🇷 France", country: "France" },
  { code: "+241", label: "🇬🇦 Gabon", country: "Gabon" },
  { code: "+220", label: "🇬🇲 Gambia", country: "Gambia" },
  { code: "+995", label: "🇬🇪 Georgia", country: "Georgia" },
  { code: "+49", label: "🇩🇪 Germany", country: "Germany" },
  { code: "+233", label: "🇬🇭 Ghana", country: "Ghana" },
  { code: "+30", label: "🇬🇷 Greece", country: "Greece" },
  { code: "+502", label: "🇬🇹 Guatemala", country: "Guatemala" },
  { code: "+224", label: "🇬🇳 Guinea", country: "Guinea" },
  { code: "+592", label: "🇬🇾 Guyana", country: "Guyana" },
  { code: "+509", label: "🇭🇹 Haiti", country: "Haiti" },
  { code: "+504", label: "🇭🇳 Honduras", country: "Honduras" },
  { code: "+852", label: "🇭🇰 Hong Kong", country: "Hong Kong" },
  { code: "+36", label: "🇭🇺 Hungary", country: "Hungary" },
  { code: "+354", label: "🇮🇸 Iceland", country: "Iceland" },
  { code: "+91", label: "🇮🇳 India", country: "India" },
  { code: "+62", label: "🇮🇩 Indonesia", country: "Indonesia" },
  { code: "+98", label: "🇮🇷 Iran", country: "Iran" },
  { code: "+964", label: "🇮🇶 Iraq", country: "Iraq" },
  { code: "+353", label: "🇮🇪 Ireland", country: "Ireland" },
  { code: "+972", label: "🇮🇱 Israel", country: "Israel" },
  { code: "+39", label: "🇮🇹 Italy", country: "Italy" },
  { code: "+225", label: "🇨🇮 Ivory Coast", country: "Ivory Coast" },
  { code: "+81", label: "🇯🇵 Japan", country: "Japan" },
  { code: "+962", label: "🇯🇴 Jordan", country: "Jordan" },
  { code: "+7", label: "🇰🇿 Kazakhstan", country: "Kazakhstan" },
  { code: "+254", label: "🇰🇪 Kenya", country: "Kenya" },
  { code: "+965", label: "🇰🇼 Kuwait", country: "Kuwait" },
  { code: "+996", label: "🇰🇬 Kyrgyzstan", country: "Kyrgyzstan" },
  { code: "+856", label: "🇱🇦 Laos", country: "Laos" },
  { code: "+371", label: "🇱🇻 Latvia", country: "Latvia" },
  { code: "+961", label: "🇱🇧 Lebanon", country: "Lebanon" },
  { code: "+266", label: "🇱🇸 Lesotho", country: "Lesotho" },
  { code: "+231", label: "🇱🇷 Liberia", country: "Liberia" },
  { code: "+218", label: "🇱🇾 Libya", country: "Libya" },
  { code: "+423", label: "🇱🇮 Liechtenstein", country: "Liechtenstein" },
  { code: "+370", label: "🇱🇹 Lithuania", country: "Lithuania" },
  { code: "+352", label: "🇱🇺 Luxembourg", country: "Luxembourg" },
  { code: "+261", label: "🇲🇬 Madagascar", country: "Madagascar" },
  { code: "+265", label: "🇲🇼 Malawi", country: "Malawi" },
  { code: "+60", label: "🇲🇾 Malaysia", country: "Malaysia" },
  { code: "+960", label: "🇲🇻 Maldives", country: "Maldives" },
  { code: "+223", label: "🇲🇱 Mali", country: "Mali" },
  { code: "+356", label: "🇲🇹 Malta", country: "Malta" },
  { code: "+222", label: "🇲🇷 Mauritania", country: "Mauritania" },
  { code: "+230", label: "🇲🇺 Mauritius", country: "Mauritius" },
  { code: "+52", label: "🇲🇽 Mexico", country: "Mexico" },
  { code: "+373", label: "🇲🇩 Moldova", country: "Moldova" },
  { code: "+377", label: "🇲🇨 Monaco", country: "Monaco" },
  { code: "+976", label: "🇲🇳 Mongolia", country: "Mongolia" },
  { code: "+382", label: "🇲🇪 Montenegro", country: "Montenegro" },
  { code: "+212", label: "🇲🇦 Morocco", country: "Morocco" },
  { code: "+258", label: "🇲🇿 Mozambique", country: "Mozambique" },
  { code: "+95", label: "🇲🇲 Myanmar", country: "Myanmar" },
  { code: "+264", label: "🇳🇦 Namibia", country: "Namibia" },
  { code: "+977", label: "🇳🇵 Nepal", country: "Nepal" },
  { code: "+31", label: "🇳🇱 Netherlands", country: "Netherlands" },
  { code: "+64", label: "🇳🇿 New Zealand", country: "New Zealand" },
  { code: "+505", label: "🇳🇮 Nicaragua", country: "Nicaragua" },
  { code: "+227", label: "🇳🇪 Niger", country: "Niger" },
  { code: "+234", label: "🇳🇬 Nigeria", country: "Nigeria" },
  { code: "+850", label: "🇰🇵 North Korea", country: "North Korea" },
  { code: "+389", label: "🇲🇰 North Macedonia", country: "North Macedonia" },
  { code: "+47", label: "🇳🇴 Norway", country: "Norway" },
  { code: "+968", label: "🇴🇲 Oman", country: "Oman" },
  { code: "+92", label: "🇵🇰 Pakistan", country: "Pakistan" },
  { code: "+970", label: "🇵🇸 Palestine", country: "Palestine" },
  { code: "+507", label: "🇵🇦 Panama", country: "Panama" },
  { code: "+675", label: "🇵🇬 Papua New Guinea", country: "Papua New Guinea" },
  { code: "+595", label: "🇵🇾 Paraguay", country: "Paraguay" },
  { code: "+51", label: "🇵🇪 Peru", country: "Peru" },
  { code: "+63", label: "🇵🇭 Philippines", country: "Philippines" },
  { code: "+48", label: "🇵🇱 Poland", country: "Poland" },
  { code: "+351", label: "🇵🇹 Portugal", country: "Portugal" },
  { code: "+974", label: "🇶🇦 Qatar", country: "Qatar" },
  { code: "+40", label: "🇷🇴 Romania", country: "Romania" },
  { code: "+7", label: "🇷🇺 Russia", country: "Russia" },
  { code: "+250", label: "🇷🇼 Rwanda", country: "Rwanda" },
  { code: "+966", label: "🇸🇦 Saudi Arabia", country: "Saudi Arabia" },
  { code: "+221", label: "🇸🇳 Senegal", country: "Senegal" },
  { code: "+381", label: "🇷🇸 Serbia", country: "Serbia" },
  { code: "+248", label: "🇸🇨 Seychelles", country: "Seychelles" },
  { code: "+65", label: "🇸🇬 Singapore", country: "Singapore" },
  { code: "+421", label: "🇸🇰 Slovakia", country: "Slovakia" },
  { code: "+386", label: "🇸🇮 Slovenia", country: "Slovenia" },
  { code: "+252", label: "🇸🇴 Somalia", country: "Somalia" },
  { code: "+27", label: "🇿🇦 South Africa", country: "South Africa" },
  { code: "+82", label: "🇰🇷 South Korea", country: "South Korea" },
  { code: "+211", label: "🇸🇸 South Sudan", country: "South Sudan" },
  { code: "+34", label: "🇪🇸 Spain", country: "Spain" },
  { code: "+94", label: "🇱🇰 Sri Lanka", country: "Sri Lanka" },
  { code: "+249", label: "🇸🇩 Sudan", country: "Sudan" },
  { code: "+597", label: "🇸🇷 Suriname", country: "Suriname" },
  { code: "+46", label: "🇸🇪 Sweden", country: "Sweden" },
  { code: "+41", label: "🇨🇭 Switzerland", country: "Switzerland" },
  { code: "+963", label: "🇸🇾 Syria", country: "Syria" },
  { code: "+886", label: "🇹🇼 Taiwan", country: "Taiwan" },
  { code: "+992", label: "🇹🇯 Tajikistan", country: "Tajikistan" },
  { code: "+255", label: "🇹🇿 Tanzania", country: "Tanzania" },
  { code: "+66", label: "🇹🇭 Thailand", country: "Thailand" },
  { code: "+228", label: "🇹🇬 Togo", country: "Togo" },
  { code: "+216", label: "🇹🇳 Tunisia", country: "Tunisia" },
  { code: "+90", label: "🇹🇷 Turkey", country: "Turkey" },
  { code: "+993", label: "🇹🇲 Turkmenistan", country: "Turkmenistan" },
  { code: "+256", label: "🇺🇬 Uganda", country: "Uganda" },
  { code: "+380", label: "🇺🇦 Ukraine", country: "Ukraine" },
  { code: "+971", label: "🇦🇪 UAE", country: "UAE" },
  { code: "+44", label: "🇬🇧 United Kingdom", country: "United Kingdom" },
  { code: "+1", label: "🇺🇸 United States", country: "United States" },
  { code: "+598", label: "🇺🇾 Uruguay", country: "Uruguay" },
  { code: "+998", label: "🇺🇿 Uzbekistan", country: "Uzbekistan" },
  { code: "+678", label: "🇻🇺 Vanuatu", country: "Vanuatu" },
  { code: "+58", label: "🇻🇪 Venezuela", country: "Venezuela" },
  { code: "+84", label: "🇻🇳 Vietnam", country: "Vietnam" },
  { code: "+967", label: "🇾🇪 Yemen", country: "Yemen" },
  { code: "+260", label: "🇿🇲 Zambia", country: "Zambia" },
  { code: "+263", label: "🇿🇼 Zimbabwe", country: "Zimbabwe" },
];






